import React, { useState, useEffect } from 'react'
import './FloatingBallsBackground.css'

const FloatingBallsBackground = ({ ballCount }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Detect mobile devices
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     window.innerWidth < 768
      setIsMobile(mobile)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Reduce ball count on mobile for better performance
  const effectiveBallCount = ballCount || (isMobile ? 3 : 8)

  return (
    <div className={`floating-balls-background ${isMobile ? 'mobile-optimized' : ''}`}>
      {Array.from({ length: effectiveBallCount }, (_, index) => (
        <span
          key={index}
          className={`floating-ball floating-ball-${index + 1}`}
        />
      ))}
    </div>
  )
}

export default FloatingBallsBackground